/**
 * Configuration de l'entreprise MAP Menuiserie
 * Source : Document Guichet Unique 2026-03-28 + RIB Société Générale 2026-04-27 + attestation décennale Groupama d'Oc 2026-05-19
 */

const decennale = {
  assureur: "Groupama d'Oc",
  assureur_siege: "Caisse Régionale d'Assurances Mutuelles Agricoles d'Oc, siège social : 14 rue Vidailhan CS 93105, 31131 Balma Cedex — 391 851 557 RCS Toulouse",
  agence: "Agence de Villefranche-Lauragais, 5 place Gambetta, 31290 Villefranche-de-Lauragais",
  police: "423233120001",
  date_effet: "20/05/2026",
  date_fin_validite: "31/12/2026",
  activites: "menuiseries intérieures (y compris aménagement de cuisines et salles de bains) et menuiseries extérieures (y compris vérandas et verrières, hors fenêtres de toit et façades rideaux)",
  couverture_geographique: "France métropolitaine et DOM",
};

const buildAssuranceMention = (d) => {
  if (d.police) {
    return `Assurance Responsabilité Civile Professionnelle et Décennale n° ${d.police} souscrite auprès de ${d.assureur} — ${d.assureur_siege}, via l'${d.agence}. Activités garanties : ${d.activites}. Couverture géographique : ${d.couverture_geographique}.`;
  }
  return `Assurance Responsabilité Civile Professionnelle et Décennale en cours de renouvellement auprès de ${d.assureur} (${d.assureur_siege}). L'attestation à jour sera transmise dès finalisation du contrat.`;
};

export const COMPANY_INFO = {
  name: "MAP Menuiserie",
  description: "Menuiserie & Agencement",
  siren: "103036372",
  siret: "10303637200011",
  nic: "00011",
  address: "20 rue Jean Cros",
  zipcode: "11410",
  city: "La Louvière-Lauragais",
  phone: "06 74 46 32 54",
  email: "contact@map-menuiserie.fr",
  regime_fiscal: "Micro BIC",
  regime_tva: "Franchise en base TVA",
  code_ape: "4332A",
  entrepreneur: "Benoit Laffargue",
  // Coordonnées bancaires (Société Générale Pamiers)
  iban: "FR76 3000 3008 9200 0220 0217 878",
  bic: "SOGEFRPP",
  // Notes légales
  tva_mention: "TVA non applicable, art. 293B du CGI",
  late_penalty: "En cas de retard de paiement, pénalité de 3x le taux légal + indemnité forfaitaire de 40€",
  // Assurance RC Pro + Décennale (attestation Groupama d'Oc 2026-05-19, valide jusqu'au 31/12/2026)
  decennale,
  assurance_mention: buildAssuranceMention(decennale),
};

// Sprint 7.2 — taux réel confirmé le 2026-09-13 (capture déclaration CA août 2026) :
// 21,2 % taux plein prestations de services artisanales BIC, réduit de 50 % flat par
// l'ACRE jusqu'au 30/03/2027 (= 10,6 %), puis retour au taux plein. La CFP (0,29 %)
// n'est PAS réduite par l'ACRE et s'ajoute en ligne séparée. CMA (0,48 % attendue) non
// incluse : pas encore confirmée sur une déclaration réelle.
export const URSSAF = {
  numeroCompte: "917 1265805588",
  tauxPrestationsPlein: 0.212,
  tauxCfp: 0.0029,
  acreReduction: 0.5,
  acreFin: "2027-03-30",
};
